import { render, staticRenderFns } from "./takingsTable.vue?vue&type=template&id=19329012&"
import script from "./takingsTable.vue?vue&type=script&lang=ts&"
export * from "./takingsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports